export const BrowserFrame = ({ src, alt, caption, className = "", testId, fill = false }) => (
  <figure className={`rounded-2xl border !border-slate-700/70 !bg-[#0F172A] shadow-2xl shadow-black/50 overflow-hidden ${fill ? "h-full flex flex-col" : ""} ${className}`} data-testid={testId}>
    <div className="flex items-center gap-1.5 border-b !border-slate-800 !bg-[#111827] px-3 py-2">
      <span className="h-2.5 w-2.5 rounded-full bg-[#EF4444]/80" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#F59E0B]/80" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#10B981]/80" />
      <span className="ml-3 flex-1 truncate rounded-md !bg-[#0A0E17] px-2 py-0.5 text-[10px] !text-slate-500">nouvellewhatsapp.it</span>
    </div>
    <img src={src} alt={alt} loading="lazy" className={`block w-full ${fill ? "flex-1 min-h-0 object-cover object-top" : "h-auto"}`} />
    {caption && <figcaption className="px-4 py-2.5 text-xs text-slate-400 border-t border-slate-800">{caption}</figcaption>}
  </figure>
);
